import { render } from "./Index.vue?vue&type=template&id=2a8b6d44&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=2a8b6d44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8b6d44"],['__file',"src/assets/js/pages/Server/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a8b6d44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a8b6d44', __exports__)) {
    api.reload('2a8b6d44', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=2a8b6d44&scoped=true", () => {
    api.rerender('2a8b6d44', render)
  })

}


export default __exports__